<template>
  <div class="left-panel-wrapper">
    <div class="left-panel">
    <div class="card section-overview">
      <div class="section-header">
        <div class="section-title">社区概况</div>
        <button class="btn btn-sm" @click="showDetails">详情</button>
      </div>
      <div class="overview-grid">
        <div v-for="item in overviewData" :key="item.label" class="data-card">
          <div class="stat-label">
            <span class="stat-icon">{{ item.icon }}</span>
            <span>{{ item.label }}</span>
          </div>
          <div class="stat-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="card section-basic-info">
      <div class="section-header">
        <div class="section-title">社区基础信息</div>
        <button class="btn btn-sm" @click="showDetails">详情</button>
      </div>

      <div class="basic-scroll">
        <div class="info-item">
          <div class="info-header"><span class="info-icon">👤</span><span class="info-title">人口</span></div>
          <div class="info-stats">
            <div v-for="stat in populationStats" :key="stat.label" class="stat-item">
              <span class="stat-label">{{ stat.label }}</span>
              <span class="stat-value">{{ stat.value }}</span>
            </div>
          </div>
        </div>

        <div class="info-item">
          <div class="info-header"><span class="info-icon">🚗</span><span class="info-title">车辆</span></div>
          <div class="info-stats">
            <div v-for="stat in vehicleStats" :key="stat.label" class="stat-item">
              <span class="stat-label">{{ stat.label }}</span>
              <span class="stat-value">{{ stat.value }}</span>
            </div>
          </div>
        </div>

        <div class="info-item">
          <div class="info-header"><span class="info-icon">🏠</span><span class="info-title">房屋</span></div>
          <div class="info-stats">
            <div v-for="stat in houseStats" :key="stat.label" class="stat-item">
              <span class="stat-label">{{ stat.label }}</span>
              <span class="stat-value">{{ stat.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { communityStore } from '../stores/community'
import { getCommunityConfig, DEFAULT_COMMUNITY } from '../utils/communityConfig'
import { REFRESH_CONFIG } from '../utils/refreshConfig'
import request from '@/utils/request'
import { getCurrentCommunity } from '@/utils/vc'

export default {
  name: 'LeftPanel',
  data() {
    // 尝试从配置中获取初始值，如果获取不到则使用默认值
    const cfg = getCommunityConfig(this.communityStore?.currentCommunity || DEFAULT_COMMUNITY)
    return {
      communityStore,
      overviewData: [],
      populationStats: (cfg.data && cfg.data.population) || [],
      vehicleStats: (cfg.data && cfg.data.vehicleStats) || [
        { label: '昨日车流量', value: 0 },
        { label: '频繁出没车辆', value: 0 },
        { label: '今日0-6时频繁出入', value: 0 }
      ],
      houseStats: (cfg.data && cfg.data.houseStats) || [
        { label: '自住房屋', value: 0 },
        { label: '租住房屋', value: 0 }
      ],
      loading: false,
      refreshTimer: null // 数据刷新定时器
    }
  },
  watch: {
    'communityStore.currentCommunity'() {
      this.loadAssetsData()
      this.loadBasicInfoData() // 加载社区基础信息（先加载接口数据）
      this.loadCommunityData() // 作为默认值备用
    }
  },
  mounted() {
    this.loadAssetsData()
    this.loadBasicInfoData() // 加载社区基础信息（先加载接口数据）
    this.loadCommunityData() // 作为默认值备用

    // 定时刷新数据
    this.refreshTimer = setInterval(() => {
      this.loadAssetsData()
      this.loadBasicInfoData()
    }, REFRESH_CONFIG.ASSETS) // 使用配置的刷新间隔
  },
  beforeDestroy() {
    // 清理定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    loadCommunityData() {
      // 社区基础信息现在从接口获取，这里只保留作为默认值
      // 注意：此方法只作为备用，不会覆盖已从接口加载的数据
      // 默认值由 loadDefaultBasicInfoData 统一处理
    },
    // 从接口获取社区基础信息（人口、车辆、房屋统计）
    loadBasicInfoData() {
      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        return
      }

      if (!communityId) {
        console.warn('communityId 为空，无法获取社区基础信息')
        return
      }

      // 调用接口获取社区基础信息
      request({
        url: '/app/bigScreen/getBasicInfo',
        method: 'get',
        params: {
          communityId: communityId
        },
        showLoading: false // 不显示加载动画
      }).then(response => {
        const res = response.data
        console.log('getBasicInfo 接口返回:', res)
        if (res && res.code === 0 && res.data) {
          const data = res.data
          console.log('getBasicInfo 数据:', data)
          console.log('车辆数据 vehicle:', data.vehicle)

          // 从配置中获取基础结构，然后根据 field 字段更新 value
          const cfg = getCommunityConfig(this.communityStore.currentCommunity)

          // 更新人口统计（根据配置中的 field 字段动态查找并更新 value）
          if (cfg.data && cfg.data.population) {
            this.populationStats = cfg.data.population.map(stat => {
              // 如果接口返回的数据中该字段不存在、为 null、undefined 或空字符串，则显示0
              let fieldValue = 0
              if (data.population && stat.field && data.population[stat.field] !== undefined && data.population[stat.field] !== null && data.population[stat.field] !== '') {
                fieldValue = Number(data.population[stat.field]) || 0
              }
              return {
                ...stat,
                value: fieldValue
              }
            })
          } else {
            // 如果配置中没有，使用默认值
            this.populationStats = [
              { label: '业主数量', value: 0 },
              { label: '租客数量', value: 0 },
              { label: '男生数量', value: 0 },
              { label: '女生数量', value: 0 }
            ]
          }

          // 更新车辆统计（根据配置中的 field 字段动态查找并更新 value）
          if (cfg.data && cfg.data.vehicleStats) {
            this.vehicleStats = cfg.data.vehicleStats.map(stat => {
              // 如果接口返回的数据中该字段不存在、为 null、undefined 或空字符串，则显示0
              let fieldValue = 0
              if (data.vehicle && stat.field && data.vehicle[stat.field] !== undefined && data.vehicle[stat.field] !== null && data.vehicle[stat.field] !== '') {
                fieldValue = Number(data.vehicle[stat.field]) || 0
              }
              return {
                ...stat,
                value: fieldValue
              }
            })
            console.log('车辆统计数据已加载:', this.vehicleStats, '原始数据:', data.vehicle)
          } else {
            // 如果配置中没有，使用默认值
            this.vehicleStats = [
              { label: '昨日车流量', value: 0 },
              { label: '频繁出没车辆', value: 0 },
              { label: '今日0-6时频繁出入', value: 0 }
            ]
            console.warn('车辆统计数据为空或无效，使用默认值。data.vehicle:', data.vehicle)
          }

          // 更新房屋统计（根据配置中的 field 字段动态查找并更新 value）
          if (cfg.data && cfg.data.houseStats) {
            this.houseStats = cfg.data.houseStats.map(stat => {
              // 如果接口返回的数据中该字段不存在、为 null、undefined 或空字符串，则显示0
              let fieldValue = 0
              if (data.house && stat.field && data.house[stat.field] !== undefined && data.house[stat.field] !== null && data.house[stat.field] !== '') {
                fieldValue = Number(data.house[stat.field]) || 0
              }
              return {
                ...stat,
                value: fieldValue
              }
            })
            console.log('房屋统计数据已加载:', this.houseStats, '原始数据:', data.house)
          } else {
            // 如果配置中没有，使用默认值
            this.houseStats = [
              { label: '自住房屋', value: 0 },
              { label: '租住房屋', value: 0 }
            ]
            console.warn('房屋统计数据为空或无效，使用默认值。data.house:', data.house)
          }
        } else {
          console.warn('获取社区基础信息失败，使用默认配置数据', res)
          this.loadDefaultBasicInfoData()
        }
      }).catch(error => {
        console.error('获取社区基础信息失败:', error)
        // 接口失败时使用默认配置数据
        this.loadDefaultBasicInfoData()
      })
    },
    // 加载默认的社区基础信息数据（从配置中）
    loadDefaultBasicInfoData() {
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      // 使用配置文件中的默认数据，如果没有则使用空数组
      this.populationStats = (cfg.data && cfg.data.population) || [
        { label: '业主数量', value: 0 },
        { label: '租客数量', value: 0 },
        { label: '男生数量', value: 0 },
        { label: '女生数量', value: 0 }
      ]
      this.vehicleStats = (cfg.data && cfg.data.vehicleStats) || [
        { label: '昨日车流量', value: 0 },
        { label: '频繁出没车辆', value: 0 },
        { label: '今日0-6时频繁出入', value: 0 }
      ]
      // 房屋统计从配置中获取
      this.houseStats = (cfg.data && cfg.data.houseStats) || [
        { label: '自住房屋', value: 0 },
        { label: '租住房屋', value: 0 }
      ]
    },
    // 从接口获取资产数据（社区概况）
    loadAssetsData() {
      if (this.loading) return
      this.loading = true

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
      }

      // 调用接口获取资产数据
      request({
        url: '/app/bigScreen/getAssets',
        method: 'get',
        params: {
          communityId: communityId
        },
        showLoading: false // 不显示加载动画
      }).then(response => {
        const res = response.data
        if (res && res.code === 0 && res.data) {
          const data = res.data
          // 根据接口返回的数据更新社区概况
          // 接口返回的字段：floorCount, roomCount, parkingSpaceCount, machineCount, populationCount, deviceCount
          // deviceCount = 视频监控设备数量 + 门禁设备数量
          // 检查数据是否有效，如果都是0或空，则使用默认数据
          const hasValidData = data.floorCount || data.roomCount || data.deviceCount || data.populationCount

          if (hasValidData) {
            this.overviewData = [
              { icon: '🏢', value: data.floorCount || 0, label: '楼栋数量' },
              { icon: '🏠', value: data.roomCount || 0, label: '房屋数量' },
              { icon: '👥', value: data.populationCount || 0, label: '人口数量' },
              { icon: '🚗', value: data.parkingSpaceCount || 0, label: '车辆数量' },
              { icon: '📱', value: data.deviceCount || 0, label: '设备数量' }
            ]
          } else {
            // 如果接口返回的数据都是0或空，使用默认配置数据
            console.warn('接口返回的数据无效，使用默认配置数据')
            this.loadDefaultOverviewData()
          }
        } else {
          // 如果接口返回失败，使用默认配置数据
          console.warn('接口返回失败，使用默认配置数据', res)
          this.loadDefaultOverviewData()
        }
      }).catch(error => {
        console.error('获取资产数据失败:', error)
        // 接口失败时使用默认配置数据
        this.loadDefaultOverviewData()
      }).finally(() => {
        this.loading = false
      })
    },
    // 加载默认的社区概况数据（从配置中）
    loadDefaultOverviewData() {
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      // 优先使用配置文件中的数据
      if (cfg && cfg.data && cfg.data.overview && cfg.data.overview.length > 0) {
        this.overviewData = cfg.data.overview
        console.log('使用配置文件中的默认数据:', this.overviewData)
      } else {
        // 如果配置文件中没有数据，使用硬编码的默认值（全部为0）
        this.overviewData = [
          { icon: '🏢', value: '0', label: '楼栋数量' },
          { icon: '🏠', value: '0', label: '房屋数量' },
          { icon: '👥', value: '0', label: '人口数量' },
          { icon: '🚗', value: '0', label: '车辆数量' },
          { icon: '📱', value: '0', label: '设备数量' }
        ]
        console.log('使用硬编码的默认数据:', this.overviewData)
      }
    },
    showDetails() {
      // TODO: 弹窗显示详情
    }
  }
}
</script>

<style lang="scss" scoped>
.left-panel-wrapper {
  position: absolute;
  top: 20px;
  left: 20px;
  width: min(400px, 20vw); // 自适应：最大400px，或屏幕宽度的20%
  min-width: 300px; // 最小宽度
  max-width: 400px; // 最大宽度
  height: calc(100% - 40px);
  z-index: 10; // 左侧面板在地图上方
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(15, 30, 50, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  
  // 响应式调整
  @media (max-width: 1920px) {
    width: min(380px, 20vw);
    max-width: 380px;
  }
  
  @media (max-width: 1600px) {
    width: min(350px, 22vw);
    max-width: 350px;
    min-width: 280px;
  }
  
  @media (max-width: 1366px) {
    width: min(320px, 24vw);
    max-width: 320px;
    min-width: 260px;
  }
}

.left-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    // 不设置 min-height，让内容自然增长
    // 不设置 overflow，让内容自然溢出，由父容器 .left-panel 处理滚动
  }
}
.left-panel ::v-deep .card {
  padding: 10px;
}
.left-panel ::v-deep .section-title {
  margin-bottom: 0;
  font-size: 14px; // 稍微缩小
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.section-overview {
  // flex 由 .card:last-child 控制（当它是最后一个时）
  overflow: hidden; // 防止内容溢出
}
.section-basic-info {
  // flex 由 .card:last-child 控制（当它是最后一个时）

  .basic-scroll {
    flex: 1;
    min-height: 0;
    padding-right: 2px;
    overflow-y: auto; // 内容超出时显示滚动条

    // 隐藏滚动条但保留滚动功能
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE/Edge

    &::-webkit-scrollbar {
      display: none; // Chrome/Safari
    }
  }
}
.overview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px; // 与 info-stats 保持一致
}
.data-card {
  display: flex;
  justify-content: space-between;
  align-items: center; // 垂直居中对齐
  padding: 7px 10px; // 与 stat-item 保持一致
  background: rgba(0, 212, 255, 0.05); // 与 stat-item 保持一致
  border: 1px solid rgba(0, 212, 255, 0.2); // 与 stat-item 保持一致
  border-radius: 4px; // 与 stat-item 保持一致
  .stat-label {
    color: #a0b3c8;
    font-size: 12px; // 与 stat-item 保持一致
    display: flex;
    align-items: center;
    gap: 6px;
    .stat-icon {
      font-size: 14px;
    }
  }
  .stat-value {
    color: #00d4ff;
    font-weight: bold;
    font-size: 12px; // 与 stat-item 保持一致
  }
}
.info-item {
  margin-bottom: 14px;
  &:last-child {
    margin-bottom: 0;
  }
}
.info-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  .info-title {
    color: #00d4ff;
    font-weight: bold;
  }
}
.info-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center; // 垂直居中对齐
  padding: 7px 10px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 4px;
  .stat-label {
    color: #a0b3c8;
    font-size: 12px;
  }
  .stat-value {
    color: #00d4ff;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>

